export default __webpack_public_path__ + "locales/ko-KR/CreateEditRoomDialog.json?hash=b20b08bb4ee9b796d9df663a81f4a564";